import { createContext, PropsWithChildren, useContext, useState } from 'react'

interface DeleteTrainingContextProps {
  isDeleteTrainingModalOpen: boolean
  setIsDeleteTrainingModalOpen: (isOpen: boolean) => void
}
const DeleteTrainingContext = createContext<DeleteTrainingContextProps | null>(
  null,
)

export const DeleteTrainingProvider = ({ children }: PropsWithChildren) => {
  const [isDeleteTrainingModalOpen, setIsDeleteTrainingModalOpen] =
    useState(false)

  return (
    <DeleteTrainingContext.Provider
      value={{ isDeleteTrainingModalOpen, setIsDeleteTrainingModalOpen }}
    >
      {children}
    </DeleteTrainingContext.Provider>
  )
}

export const useDeleteTrainingContext = () => {
  const context = useContext(DeleteTrainingContext)

  if (!context) {
    throw new Error(
      'useDeleteTrainingContext must be used within a DeleteTrainingProvider',
    )
  }

  return context
}
